export const pageCountGet = (itemCount, maxPerPage) => {
    const res = parseInt((itemCount - 1) / maxPerPage) + 1;
    return res;
};
  
export const baseUrlGet = () => {
    const url = window.location.href;
    const arr = url.split("/");
    let res = arr[0] + "//" + arr[2];
    if (res.includes('localhost:3001')) {
        res = res.replace('localhost:3001', 'localhost:3000');
    }
    // console.log('baseUrlGet');    
    return res;
};

export const statFileUrl = (fold, fNam) => {
    let res = '';
    if (typeof fold !== 'undefined' && typeof fNam !== 'undefined' && fNam != '') {
        const urlBase = baseUrlGet();
        res = urlBase + '/stat-u/' + fold + '/' + fNam;                
    }
    return res;
};

export const indArrNorm = (ind, n) => {
    if (ind < 0 || n == 0) {
        ind = 0;        
    } else if (ind >= n) {
        ind = n - 1;        
    }
    return ind;
};

export const textShort = (s, n) => {
    n = typeof n !== 'undefined' ? n : 100;
    if (s.length > n) {
        const ind = s.indexOf(' ', n);
        s = s.substr(0, ind);        
    }
    return s;
};
